import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SelectBoxServiceService {

  public open_and_close = new EventEmitter<boolean>();

  constructor() { }
}
